var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06522 0.000976562C2.92966 0.000976562 3.63043 0.701732 3.63043 1.56616V20.8701H22.9348C23.7992 20.8701 24.5 21.5708 24.5 22.4352C24.5 23.2997 23.7992 24.0004 22.9348 24.0004H2.06522C1.20077 24.0004 0.5 23.2997 0.5 22.4352V1.56616C0.5 0.701732 1.20077 0.000976562 2.06522 0.000976562Z",
    fill: "#8086B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9795 4.41103C24.6162 5.00999 24.6755 6.04413 24.112 6.72085L18.2639 13.7438C17.9878 14.0754 17.597 14.2739 17.1808 14.2939C16.7647 14.314 16.3586 14.1539 16.0554 13.8502L12.5212 10.3106L7.62748 15.5196C7.02671 16.1591 6.05197 16.1598 5.45034 15.5213C4.84871 14.8827 4.84801 13.8467 5.44878 13.2072L11.3992 6.87338C11.9876 6.24697 12.9381 6.23159 13.5442 6.83867L17.011 10.3107L21.8064 4.55183C22.3699 3.87511 23.3428 3.81207 23.9795 4.41103Z",
    fill: "#8086B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.f7ac3fc6.svg";
export { ForwardRef as ReactComponent };